import { IQuestionEditorApi, IQuestionEditorState } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import { IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import { updateStatusQuestionChangedAction } from 'app_events/editor/actions';
import storeService from 'app_services/storeService'
import { store } from 'app_storage/redux-storage'
import { getContentFromSendFillInSpaces } from 'app_utils/functions/editorFunctions'
import { getColorFromCSS } from 'app_utils/functions/getTheme';
import { Http, HttpCustomStructure } from 'app_utils/http'
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { TypesQuestionCategories } from 'app_types/userTypes'
import shortId from 'shortid';
import Swal from 'sweetalert2'

interface IAnswerQuery{
  content: string
  value: number
  is_correct?: boolean
  config? : {
    fill_in_spaces?: {
      slug: string
      label: string
      value: number,
    }[]
    relate_item? : {
      slug: string
      type: 'question' | 'relation'
      connection?: string[],
    },
  }
}

interface ISearchQuestionsQuery{
  search: string
  nPerPage: number
  pageNumber: number
  tags?: string[]
  metadata?: any[]
  alliance_id?: string
  incremental_code?: string[]
  teacher_id?: string
}

interface IParamsGetQuestion{
  id: string
  alliance_id: string
}

export interface ICreateQuestionQuery{
  content: string
  question_category: string
  parent?: string
  value?: number
  answers?: IAnswerQuery[]
  owner?: string
}

class QuestionsService {

  private token: string
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private storeObject = store
  private alliance: any
  private i18nUtil = new I18nUtil()

  constructor() {
    this.Http = Http
    this.screenNotification = new ScreenNotificationsUtil()
    this.token = this.storeObject.getState().auth?.user?.token as string
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  /**
   * @INFO Crear pregunta
   */
  createQuestion = async (_params: ICreateQuestionQuery) => {
    this.refreshAuthToken()

    let responseData: any
    let params = {..._params}

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Question-Category': params.question_category,
      },
      method: 'POST',
      url: `/api/admin/question/create`,
      auth_token: this.token,
      params,
    }
    //console.log('PARAMS Crear pregunta  : ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Crear pregunta :  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Actualizar pregunta
   */
  updateQuestion = async (id: string, category: TypesQuestionCategories, params: any) => {
    this.refreshAuthToken()

    let sendParams = {}
    switch(category){
      case 'multiple-choice-unique-answer':
      case 'multiple-choice-multiple-answer':
        const answers = params.answers.reduce((acum: {content: string, value: number, is_correct: boolean, feedback: string, config: any}[], item: any) => {
          acum.push({
            content: item.content,
            value: Number(item.value),
            is_correct:  item.is_correct,
            feedback: item.feedback,
            config: item.config,
          })
          return acum
        },[])
        sendParams = {
          content: params.content,
          answers,
        }
        break
      case 'open-answer':
        sendParams = {
          content: params.content,
        }
        break
      case 'container':
        sendParams = {
          content: params.content,
        }
        break
      case 'select-range':
        sendParams = {
          content: params.content,
        }
        break
      default:
        break
    }

    sendParams = {
      ...sendParams,
      metadata: params.metadata ? params.metadata : [],
      tags: params.tags ? params.tags : [],
      config: params.config ? params.config : undefined,
    }

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Question-Category': storeService?.getQuestionCategoryFromName(category),
      },
      method: 'POST',
      url: `/api/admin/question/update/${id}`,
      auth_token: this.token,
      params: sendParams,
    }
    //console.log('PARAMS Actualizar pregunta : ', sendParams);
    responseData = await this.Http.send(queryData)
    //console.log('Actualizar pregunta:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener una pregunta por ID
   * @param params
   */
  public getQuestion = async (params: IParamsGetQuestion) => {
    this.refreshAuthToken()

    let responseData: any
    const url = `/api/question/${params.alliance_id}/${params.id}`

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url,
      auth_token: this.token,
    }
    //console.log('GET: Params get question: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('GET: Response get question:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      // await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Actualizar la metadata de una pregunta
   * @param alliance
   * @param question
   * @param category
   * @returns
   */
  public updateMetadataQuestion = async (alliance: string, question: IQuestionEditor, category: TypesQuestionCategories) => {
    this.refreshAuthToken()
    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Question-Category': storeService?.getQuestionCategoryFromName(category),
      },
      method: 'POST',
      url: `/api/question/${alliance}/update/${question.question._id}`,
      auth_token: this.token,
      params: {...question.question},
    }
    //console.log('PARAMS Actualizar metadata pregunta : ', {...question});
    responseData = await this.Http.send(queryData)
    //console.log('Actualizar metadata pregunta:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Buscar preguntas por Query
   * @param allianceId
   * @param params
   */
  searchQuestions = async (allianceId: string, params: ISearchQuestionsQuery) => {
    this.refreshAuthToken()
    params.alliance_id = allianceId

    let responseData: any
    const url = `/api/lms/question/${allianceId}/fetch-questions`
    //console.log('Url de buscar preguntas: ', url);

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'POST',
      url,
      auth_token: this.token,
      params,
    }
    //console.log('PARAMS Buscar preguntas  : ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Buscar preguntas :  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Encontrar el padre pasando desde cualquier pregunta
   * @param questions
   * @param child
   */
  public getParentFromChild = (questions: IQuestionEditorState[], question: IQuestionEditorState) => {
    const auxQuestions = [...questions]
    if(!auxQuestions?.length || !question) return undefined
    if(question.question?.parent){
      const idxParent = auxQuestions.findIndex((item) => item.question._id === question.question.parent)
      if(idxParent >= 0){
        return {...auxQuestions[idxParent]}
      }else{
        return undefined
      }
    }else{
      return {...question}
    }
  }

  /**
   * @INFO Obtener los hijos del padre desde el padre o desde un hijo
   * @param questions
   * @param question
   */
  public getChildsParentFromAnyQuestion = (questions: IQuestionEditorState[], question: IQuestionEditorState) => {
    const auxQuestions = [...questions]
    let response: any[] = []
    if(!auxQuestions?.length || !question) return response
    if(question.question.parent){
      // @INFO Encontrar el padre
      const idxParent = auxQuestions.findIndex((item) => item.question._id === question.question.parent)
      if(idxParent >= 0){
        const childs = auxQuestions[idxParent].childs
        if(childs !== undefined){
          response = childs
        }
      }
    }else{
      if(question.childs){
        response = question.childs
      }
    }
    return response
  }

  /**
   * @INFO Verificar si existe algún cambio en la pregunta
   */
  public hasAnyChange = () => {
    const state = this.storeObject.getState().editor.statusQuestionChanged
    return state
  }

  /**
   * @INFO Actualizar el estado de modificación en alguna pregunta
   * @param state
   */
  public updateStatusChanged = (_state: boolean) => {
    const state = this.storeObject.getState().editor.statusQuestionChanged
    if(state !== _state){
      this.storeObject.dispatch(updateStatusQuestionChangedAction(_state))
    }
  }

  /**
   * @INFO Validar si se puede cambiar de pregunta o no
   * @returns
   */
  public validateChangeQuestion = async () => {
    const state = this.storeObject.getState().editor.statusQuestionChanged
    if(state){
      const data = await Swal.fire({
        title: `¡${this.i18nUtil.getTranslate('editor.resources.exercise.alert')}!`,
        text: `${this.i18nUtil.getTranslate('editor.resources.exercise.continue_without_save')}`,
        showCancelButton: true,
        confirmButtonText: this.i18nUtil.getTranslate('editor.resources.exercise.continue'),
        cancelButtonText: this.i18nUtil.getTranslate('editor.resources.exercise.cancel'),
        confirmButtonColor: getColorFromCSS('--primary'),
        icon: 'warning',
      })
      if(data.isConfirmed){
        this.updateStatusChanged(false)
        return true
      }else{
        return false
      }
    }else{
      return true
    }
  }

  /**
   * ! Para simulacros
   * @INFO Obtener la pregunta formateada para utilizarla en el editor y sus componentes
   * @param _question
   */
  public getFormateQuestionEditor = (_question: any) => {
    // @INFO Asignar la pregunta para editarla
    const auxCurrentQuestion: IQuestionEditorState = {
      question: {
        ..._question,
      },
      position: 1,
      value: 1,
      id: shortId.generate(),
      selected: false,
    }
    // @INFO Si el _id viene con otro formato lo actualizo
    if(!auxCurrentQuestion.question._id){
      auxCurrentQuestion.question._id = _question.id
    }
    // @INFO Verificar formato del parent
    // @ts-ignore
    if(auxCurrentQuestion.question?.parent?._id){
      // @ts-ignore
      auxCurrentQuestion.question.parent = auxCurrentQuestion.question.parent._id
    }
    // @INFO Colocar question category completo
    if(typeof auxCurrentQuestion.question?.question_category === 'string'){
      // @ts-ignore
      const category: IQuestionCategory | undefined = storeService?.getQuestionCategoryFromId(auxCurrentQuestion.question.question_category)
      if(category){
        auxCurrentQuestion.question.question_category = category
      }
    }else if(auxCurrentQuestion.question.question_category?._id){
      // @ts-ignore
      const category: IQuestionCategory | undefined = storeService?.getQuestionCategoryFromId(auxCurrentQuestion.question.question_category._id)
      if(category){
        auxCurrentQuestion.question.question_category = category
      }
    }
    // @INFO Si la pregunta tiene childs darle el formato también
    // @ts-ignore
    if(auxCurrentQuestion.question?.childs?.length){
      // @ts-ignore
      auxCurrentQuestion.childs = auxCurrentQuestion.question?.childs.reduce((acum: IQuestionEditorState[], item: any) => {
        const newChild = this.getFormateQuestionEditor(item)
        acum.push(newChild)
        return acum
      },[])
    }
    // @INFO Si es contenedor ponerlo en "selected"
    if(auxCurrentQuestion.question.question_category.name === 'container'){
      auxCurrentQuestion.selected = true
    }
    return {...auxCurrentQuestion}
  }

  /**
   * @INFO Obtener las preguntas formateadas desde una lista de preguntas
   * * Nota: Deben venir con los childs organizados
   * @param _questions
   * @returns
   */
  public getQuestionsListFormate = (_questions: any[], currentPosition?: number) => {
    if(!_questions?.length) return []
    const questions = [..._questions]
    let contQuestions: number = currentPosition ? (currentPosition+1) : 1
    const newQuestions = questions.reduce((acum:IQuestionEditorState[], item: any) => {

      const newQuestion = this.getFormateQuestionEditor(item)

      // @INFO Asignarle una posición
      if(newQuestion.question.question_category.name !== 'container'){
        newQuestion.position = contQuestions
        contQuestions += 1
      }else{
        if(newQuestion.childs?.length){
          for(let i=0 ; i<newQuestion.childs.length; i++){
            if(newQuestion.childs[i].question.question_category.name !== 'container'){
              newQuestion.childs[i].position = contQuestions
              contQuestions += 1
            }
          }
        }
      }
      acum.push({...newQuestion})
      return acum
    },[])
    return newQuestions
  }

  /**
   * @INFO Obtener array de string con los Id de las preguntas solas o de estimulo (incluye el contenedor y los hijos)
   * @param _questions
   * @param _question
   * @returns
   */
  public getIdsQuestion = (_questions: IQuestionEditorState[], _question: string) => {
    if(!_questions?.length || !_question) return []
    const questions = [..._questions]
    const questionId = _question
    // @INFO Encontrar la pregunta
    const question = questions.reduce((acum: IQuestionEditorState | undefined, item) => {
      if(!acum){
        if(item.question._id === questionId){
          acum = {...item}
        }else if(item.childs?.length){
          const idxQuestion = item.childs.findIndex(item2 => item2.question._id === questionId)
          if(idxQuestion >= 0){
            acum = {...item.childs[idxQuestion]}
          }
        }
      }
      return acum
    }, undefined)
    // @INFO Organizar la respuesta
    if(question){
      if(question.childs?.length){
        const response = question.childs.reduce((acum: string[], item) => {
          acum.push(item.question._id)
          return acum
        },[])
        response.push(question.question._id)
        return response
      }else{
        const response = [question.question._id]
        if(question.question.parent){
          response.push(question.question.parent)
        }
        return response
      }
    }
    return []
  }

  /**
   * @INFO Validar si una pregunta se puede editar o no
   * @param question
   */
  public validateEditPermission = (_question : IQuestionEditorApi) => {
    return true
  }

  /**
   * @INFO Ordenar preguntas según la variable posición
   * @param questions
   */
   public orderQuestions = (questions: IQuestionEditor[]) => {
    if(!questions?.length) return []
    let newQuestions: IQuestionEditor[] = []
    questions.reduce((accum: number, item) => {
      questions.forEach((question: IQuestionEditor) => {
        if(question.question.question_category.name === 'container'){
          if(question.childs?.length){
            if(question.childs[0].position === accum){
              newQuestions.push({...question})
              accum += question.childs.length
            }
          }
        }else if(question.position === accum){
          newQuestions.push({...question})
          accum += 1
        }
      })
      if(
        item.question.question_category.name === 'container' &&
        !item.childs?.length
      ){
        newQuestions.push({...item})
      }
      return accum
    }, 1)
    return [...newQuestions]
  }

  /**
   * @INFO Traer la lista de event types para preguntas
   */
  public listQuestionEventTypes = async () => {
    this.refreshAuthToken()
    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/event-question-type`,
      auth_token: this.token,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Traer lista de términos y condiciones
   * @param _params : Opciones de búsqueda
   */
  public listTermAndConditions = async (_params?: {alliance?: string}) => {
    this.refreshAuthToken()
    let responseData: any

    let allianceId = this.alliance?.id
    if(_params?.alliance){
      allianceId = _params.alliance
    }

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/terms-and-conditions/${allianceId}`,
      auth_token: this.token,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

}

export default QuestionsService
